import type { ApplicationKey } from '@atlassian/jira-shared-types/src/application-key.tsx';
import type { ApplicationEdition } from '@atlassian/jira-shared-types/src/edition.tsx';

export const useShouldSeeButton = ({
	applicationKey,
	applicationEdition,
	canUpgrade,
}: {
	applicationKey: ApplicationKey;
	applicationEdition: ApplicationEdition;
	canUpgrade: boolean;
}) => {
	if (canUpgrade && applicationEdition === 'FREE_EDITION') {
		// Released 100% for JSM
		if (applicationKey === 'jira-servicedesk') {
			return true;
		}
		if (applicationKey === 'jira-software') {
			// Released 100% for JSW & JWM
			return true;
		}
		if (applicationKey === 'jira-product-discovery') {
			return true;
		}
	}

	return false;
};
